import type { Entity } from '@backstage/catalog-model';

import { useEntityRefLink } from '@backstage/plugin-catalog-react';
import { Avatar, ListRow } from '@backstage/ui';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import classes from './HomeCardEntityItem.module.css';

type Props = { className?: string; showImages?: boolean } & (
  | { entity: Entity; loading?: false }
  | { loading: true }
);

export const HomeCardEntityItem = (props: Props) => {
  const entityRefLink = useEntityRefLink();
  const navigate = useNavigate();
  const showImages = props.showImages ?? true;

  if (props.loading) {
    return (
      <ListRow
        className={clsx(classes.root, props.className)}
        icon={showImages ? <div className={clsx(classes.skeleton, classes.logoSkeleton)} /> : undefined}
        textValue="Loading"
      >
        <div aria-hidden="true" className={classes.loadingText}>
          <div className={clsx(classes.skeleton, classes.titleSkeleton)} />
          <div className={clsx(classes.skeleton, classes.descriptionSkeleton)} />
        </div>
      </ListRow>
    );
  }

  const { entity } = props;
  const title = entity.metadata.title ?? entity.metadata.name;
  const logo = entity.spec?.logo;

  return (
    <ListRow
      className={clsx(classes.root, props.className)}
      description={entity.metadata.description}
      icon={showImages
        ? typeof logo === 'string'
          ? <Avatar className={classes.logo} name={title} src={logo} />
          : <div aria-hidden="true" className={classes.logoFallback}>{title.slice(0, 1)}</div>
        : undefined}
      onAction={() => navigate(entityRefLink(entity))}
    >
      {title}
    </ListRow>
  );
};
